import { useEffect } from "react";
import { buildSiteUrl } from "../config/runtime";

function upsertMeta(selector, attributes, content) {
  if (!content) return;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function upsertCanonical(url) {
  if (!url) return;
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }
  element.setAttribute("href", url);
}

function resolveAbsoluteUrl(value, fallbackPath) {
  const raw = String(value || fallbackPath || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  return buildSiteUrl(raw.startsWith("/") ? raw : `/${raw}`);
}

export default function MetaManager({ seo, fallbackTitle, fallbackDescription, fallbackPath = "/" }) {
  useEffect(() => {
    const title = String(seo?.title || fallbackTitle || "").trim();
    const description = String(seo?.description || fallbackDescription || "").trim();
    const ogTitle = String(seo?.ogTitle || title).trim();
    const ogDescription = String(seo?.ogDescription || description).trim();
    const ogImage = resolveAbsoluteUrl(seo?.ogImage, "/logo.png");
    const canonicalUrl = resolveAbsoluteUrl(seo?.canonicalUrl, fallbackPath);

    if (title) {
      document.title = title;
    }

    upsertMeta('meta[name="description"]', { name: "description" }, description);
    upsertMeta('meta[property="og:type"]', { property: "og:type" }, "website");
    upsertMeta('meta[property="og:title"]', { property: "og:title" }, ogTitle);
    upsertMeta('meta[property="og:description"]', { property: "og:description" }, ogDescription);
    upsertMeta('meta[property="og:image"]', { property: "og:image" }, ogImage);
    upsertMeta('meta[property="og:url"]', { property: "og:url" }, canonicalUrl);
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card" }, "summary_large_image");
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title" }, ogTitle);
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description" }, ogDescription);
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image" }, ogImage);
    upsertCanonical(canonicalUrl);
  }, [fallbackDescription, fallbackPath, fallbackTitle, seo]);

  return null;
}
